import {
  Box,
  IconButton,
  type IconButtonProps,
  MenuButton,
  Menu as MenuC,
  MenuList as MenuListC,
  type MenuProps,
  Stack,
} from '@chakra-ui/react'

import MenuItem from '@/components/UI/MenuItem'
import Tippy from '@/components/UI/Tippy'

import Divider from '../Divider'
import OptionalLink from '../OptionalLink'
import type { MenuItemType } from './types'

export function MenuList({
  itemGroups,
  className,
}: {
  itemGroups: MenuItemType[][]
  className?: string
}): JSX.Element {
  return (
    <MenuListC zIndex="dropdown" className={className}>
      <Stack direction="column" divider={<Divider />} spacing="8px">
        {itemGroups.map(group => (
          <Stack direction="column" spacing="0px" key={group[0].label}>
            {group.map(
              ({ label, icon, onClick, color, tooltip, href, isExternal = true, disabled }) => (
                <Box key={label}>
                  <Tippy key={label} disabled={tooltip == null} content={tooltip}>
                    <OptionalLink href={href} width="100%" isExternal={isExternal}>
                      <MenuItem
                        icon={icon}
                        value={label}
                        label={label}
                        color={color}
                        onClick={onClick}
                        disabled={disabled ?? false}
                      />
                    </OptionalLink>
                  </Tippy>
                </Box>
              )
            )}
          </Stack>
        ))}
      </Stack>
    </MenuListC>
  )
}

export default function Menu({
  buttonProps,
  itemGroups,
  className,
  ...props
}: {
  buttonProps: IconButtonProps
  itemGroups: MenuItemType[][]
  className?: string
} & Omit<MenuProps, 'children'>): JSX.Element {
  return (
    <MenuC {...props}>
      <MenuButton as={IconButton} variant="icon" {...buttonProps} />
      <MenuList itemGroups={itemGroups} className={className} />
    </MenuC>
  )
}
